import { render } from "./uploadAvatar.vue?vue&type=template&id=252e5ba4&scoped=true"
import script from "./uploadAvatar.vue?vue&type=script&lang=js"
export * from "./uploadAvatar.vue?vue&type=script&lang=js"

import "./uploadAvatar.vue?vue&type=style&index=0&id=252e5ba4&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e5ba4"]])

export default __exports__